"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniswapExchange = void 0;
var UniswapExchangeAbi_json_1 = __importDefault(require("./UniswapExchangeAbi.json"));
exports.UniswapExchange = UniswapExchangeAbi_json_1.default;
